/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateReservationRequestReservationPolicy } from './CreateReservationRequestReservationPolicy';
import {
    CreateReservationRequestReservationPolicyFromJSON,
    CreateReservationRequestReservationPolicyFromJSONTyped,
    CreateReservationRequestReservationPolicyToJSON,
    CreateReservationRequestReservationPolicyToJSONTyped,
} from './CreateReservationRequestReservationPolicy';

/**
 * 
 * @export
 * @interface CreateReservationRequestReservation
 */
export interface CreateReservationRequestReservation {
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    dateTime: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequestReservation
     */
    diners: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    customerComments?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    zone: string;
    /**
     * 
     * @type {CreateReservationRequestReservationPolicy}
     * @memberof CreateReservationRequestReservation
     */
    policy: CreateReservationRequestReservationPolicy;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReservationRequestReservation
     */
    notify?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    endTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservation
     */
    source?: string;
}

/**
 * Check if a given object implements the CreateReservationRequestReservation interface.
 */
export function instanceOfCreateReservationRequestReservation(value: object): value is CreateReservationRequestReservation {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('surname' in value) || value['surname'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('diners' in value) || value['diners'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    return true;
}

export function CreateReservationRequestReservationFromJSON(json: any): CreateReservationRequestReservation {
    return CreateReservationRequestReservationFromJSONTyped(json, false);
}

export function CreateReservationRequestReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservationRequestReservation {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'surname': json['surname'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'dateTime': json['dateTime'],
        'diners': json['diners'],
        'customerComments': json['customerComments'] == null ? undefined : json['customerComments'],
        'zone': json['zone'],
        'policy': CreateReservationRequestReservationPolicyFromJSON(json['policy']),
        'notify': json['notify'] == null ? undefined : json['notify'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'source': json['source'] == null ? undefined : json['source'],
    };
}

export function CreateReservationRequestReservationToJSON(json: any): CreateReservationRequestReservation {
    return CreateReservationRequestReservationToJSONTyped(json, false);
}

export function CreateReservationRequestReservationToJSONTyped(value?: CreateReservationRequestReservation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'surname': value['surname'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'dateTime': value['dateTime'],
        'diners': value['diners'],
        'customerComments': value['customerComments'],
        'zone': value['zone'],
        'policy': CreateReservationRequestReservationPolicyToJSON(value['policy']),
        'notify': value['notify'],
        'endTime': value['endTime'],
        'source': value['source'],
    };
}

